interface Props {
  id: string
  children: React.ReactNode | React.ReactNode[]
  [props: string]: any
}

const DraggableCell = ({ children, id, ...props }: Props) => {
  return (
    <div {...props} id={id}>
      {children}
    </div>
  )
}

export default DraggableCell
